import { format } from "@suse-o11y/date-time";
import { toRelativeDateTerm } from "@suse-o11y/date-time/to-relative-date-term";
import { convertTimeFrom } from "@suse-o11y/formatter-unit/convert-time-from";
import { isShallowEqual } from "@suse-o11y/is-shallow-equal";
import { useNow } from "@suse-o11y/use-now";
import React from "react";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../../common/openapi";

export function InternalPastRuleTiming({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	const duration = convertTimeFrom("millisecond", rule.endTimeEpochMs - rule.startTimeEpochMs, 0, {
		shorthandUnits: true,
		maximumUnit: "hour",
	});

	const [sinceDayOrDate, untilDayOrDate] = useNow({
		interval: 1000,
		floor: "seconds",
		compare: isShallowEqual,
		transform: (now) => [toRelativeDateTerm(now, rule.startTimeEpochMs), toRelativeDateTerm(now, rule.endTimeEpochMs)],
	});

	const sinceTime = format(rule.startTimeEpochMs, "HH:mm:ss");
	const untilTime = format(rule.endTimeEpochMs, "HH:mm:ss");

	return (
		<section className="space-y-3">
			<h2 className="text-15/[22px] text-core-text-neutral-primary">Muted for</h2>
			<p className="mb-0 text-core-text-neutral-secondary">
				<strong className="font-semibold">{duration}</strong> between {sinceDayOrDate}, {sinceTime} and {untilDayOrDate}
				, {untilTime}.
			</p>
		</section>
	);
}
